import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
  Grid,
  Checkbox,
} from '@mui/material';
import { AppContext } from '../../../../context/AppContextProvider';
import ButtonComponent from '../../../../components/ButtonComponent';
import {
  useGetOnlineModeByIdAsync,
  useUpdateOnlineModeAsync,
} from '../../../../services/OnlineModeService/useMutation';

const OnlineModeManagementTab = () => {
  const { showSnackbar } = useContext(AppContext);
  const [isOnlineModeEnabled, setIsOnlineModeEnabled] = useState(false);
  const [schoolShiftEnabled, setSchoolShiftEnabled] = useState(false);
  const [exitByResponsibleArrival, setExitByResponsibleArrival] =
    useState(false);
  const [cardVerify, setCardVerify] = useState(false);
  const [resBlock, setResBlock] = useState(false);

  const { mutateAsync: getOnlineMode } = useGetOnlineModeByIdAsync();
  const { mutateAsync: updateOnlineMode, isLoading } =
    useUpdateOnlineModeAsync();

  useEffect(() => {
    getOnlineMode().then((data) => {
      setIsOnlineModeEnabled(data.activeOnlineMode);
      setSchoolShiftEnabled(data.schoolShiftOn);
      setExitByResponsibleArrival(data.exitWithResponsable);
      setCardVerify(data.cardVerify);
      setResBlock(data.resBlock);
    });
  }, []);

  const handleSave = () => {
    updateOnlineMode({
      data: {
        activeOnlineMode: isOnlineModeEnabled,
        schoolShiftOn: schoolShiftEnabled,
        exitWithResponsable: exitByResponsibleArrival,
        cardVerify: cardVerify,
        resBlock: resBlock,
      },
    }).then(() => {
      showSnackbar('Configurações salvas com sucesso.', 'success');
    });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Configurações do Modo Online
      </Typography>

      <Typography variant="body1" sx={{ mt: 2 }}>
        Para ativar o modo online no seu dispositivo e garantir o funcionamento
        correto com nosso sistema, siga os passos abaixo:
      </Typography>

      <Typography variant="body2" sx={{ mt: 1 }}>
        1. <strong>Obtenha a referência do dispositivo:</strong> No nosso
        sistema, cada dispositivo tem um identificador único. Essa referência
        será usada para apontar corretamente os eventos de autenticação e
        notificações.
      </Typography>
      <Typography variant="body2">
        2. <strong>Ative o Modo Online:</strong> Use o botão abaixo para ativar
        o modo online no sistema.
      </Typography>
      <Typography variant="body2">
        3. <strong>Configure o Dispositivo:</strong>
        <ul>
          <li>
            <strong>Endereço IP:</strong> IP do servidor onde o sistema está
            hospedado (ex: 10.12.14.2)
          </li>
          <li>
            <strong>Porta:</strong> Porta configurada para receber as
            notificações (Padrão: 5298)
          </li>
          <li>
            <strong>URL do Servidor:</strong> /notification/{'{referencia}'}
          </li>
          <li>
            <strong>Exemplo:</strong> /notification/5 (onde 5 é a referência do
            dispositivo)
          </li>
          <li>
            <strong>Endereço Heartbeat:</strong> /keepalive
          </li>
          <li>
            <strong>Timeouts:</strong> Configure conforme sua infraestrutura
            (ex: 2000ms para heartbeat, 100ms para autenticação)
          </li>
        </ul>
      </Typography>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={isOnlineModeEnabled}
                onChange={() => setIsOnlineModeEnabled((prev) => !prev)}
              />
            }
            label="Ativar Modo Online"
          />
        </Grid>

        {isOnlineModeEnabled && (
          <>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={schoolShiftEnabled}
                    onChange={() => setSchoolShiftEnabled((prev) => !prev)}
                  />
                }
                label="Habilitar Turno Escolar"
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={exitByResponsibleArrival}
                    onChange={() =>
                      setExitByResponsibleArrival((prev) => !prev)
                    }
                  />
                }
                label="Saída por chegada do responsável"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={cardVerify}
                    onChange={() => setCardVerify((prev) => !prev)}
                  />
                }
                label="Saída com checagem de cartão"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={resBlock}
                    onChange={() => setResBlock((prev) => !prev)}
                  />
                }
                label="Bloqueio de Responsáveis"
              />
            </Grid>
          </>
        )}

        <Grid item xs={12}>
          <ButtonComponent onClick={handleSave} loading={isLoading}>
            Salvar
          </ButtonComponent>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OnlineModeManagementTab;
